module.exports = __webpack_public_path__ + "static/media/yellowhead-11.1fd81132.jpg";